import { LOCATION_CHANGE } from 'redux-first-history';
import { locationChangeAction } from 'redux-first-history/build/es6/actions';
import { createAction } from 'typesafe-actions';

export const locationChange = createAction(LOCATION_CHANGE)<ReturnType<typeof locationChangeAction>['payload']>();
